var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageAlerted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4766 0.751001C10.1869 3.38065 7.09496 6.70176 5.83959 8.17771L2.6163 5.65259C2.53095 5.59121 0.761544 7.1621 0.808537 7.21101L6.67874 13.179C6.7219 13.2279 6.78136 13.25 6.84561 13.25C6.85712 13.25 6.87534 13.25 6.89069 13.2462C6.96741 13.2289 7.03262 13.1771 7.06139 13.1004C8.00699 10.6827 11.1296 5.62094 15.1172 1.94979C15.1882 1.88265 15.2131 1.77716 15.1738 1.68605C15.1728 1.68509 14.536 0.714558 14.4766 0.751001Z",
    fill: "#B3B3B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageAlerted);
export default __webpack_public_path__ + "static/media/messageAlerted.0e7e75fe.svg";
export { ForwardRef as ReactComponent };